// @flow
/* eslint-disable no-unused-vars */
import * as wjcCore from 'wijmo/wijmo';

import { createColumnOrRowFormatter } from '../../../utils';
import type { FormatterArgs } from '../../../types';

const statusFormatter = (args?: FormatterArgs) =>
  createColumnOrRowFormatter({
    columnName: 'Status',
    formatStyle: 'row', // can be wheter 'row' or 'cell'.
    formatter: ({ elem, dataItem }) => {
      const item = dataItem;

      let color;

      switch (item.Status) {
        case 'COD(SLA)':
        case 'COD(INT)':
        case 'COD(POL)':
          color = 'yellow';
          break;
        case 'Expired':
        case 'Inactive':
          color = 'orange';
          break;
        case 'PAST DUE':
          color = 'red';
          break;
        default:
          color = '';
          break;
      }

      wjcCore.addClass(elem.cell, color);
    },
  });

export default statusFormatter;
